import * as React from 'react';
import VersionNumber from '../../VersionNumber';
import { LoginLink } from '@shopee-user/shared-customization-ui';

// Utils
import { useResponsiveLayout, Layout } from '@shopee-user/layout-responsive';

import styles from './style.scss';

export function Footer() {
  const { layout } = useResponsiveLayout();

  const DesktopLoginLink = layout === Layout.Desktop && <LoginLink />;
  return (
    <div className={styles.footer}>
      {DesktopLoginLink}
      <VersionNumber />
    </div>
  );
}
